import { FC } from 'react';
import { Divider, MenuItem, ListItemText } from '@mui/material';
import { TREE_KEYBOARD_SHORTCUTS } from '@/lib/tree/treeKeyboardShortcuts';

/** Compact menu hint; full shortcut table lives in documentation. */
export const TreeKeyboardShortcutsMenuFooter: FC = () => (
  <>
    <Divider />
    <MenuItem disabled dense sx={{ opacity: 1, whiteSpace: 'normal' }}>
      <ListItemText
        primary="Keyboard shortcuts"
        secondary={`Use ${TREE_KEYBOARD_SHORTCUTS.add} to add and ${TREE_KEYBOARD_SHORTCUTS.reload} to reload. Full list: User Guide > General > Tree keyboard shortcuts.`}
        slotProps={{
          primary: { variant: 'caption', fontWeight: 600 },
          secondary: { variant: 'caption' },
        }}
      />
    </MenuItem>
  </>
);
